const step_up = {
    verify_your_identity: 'Підтвердьте свою особу',
    choose_method_description: 'Щоб продовжити, підтвердьте, що це ви, одним із наведених способів.',
    password: 'Пароль',
    password_description: 'Введіть пароль свого облікового запису',
    enter_password_description: 'Введіть пароль свого облікового запису, щоб продовжити.',
    enter_verification_code_description: 'Введіть код підтвердження, надісланий на {{identifier}}.',
    subject_proof_description: 'Щоб продовжити, підтвердьте, що це ви, через обліковий запис, пов’язаний із вашим. Після цього ви зможете налаштувати спосіб перевірки.',
    no_method_available: 'Немає доступного способу перевірки',
    no_method_available_description: 'У вашому обліковому записі немає способу, яким можна пройти цю перевірку. Будь ласка, зверніться до адміністратора по допомогу.',
};
export default Object.freeze(step_up);
